/*
 * Copyright (c) 2025 AirAsia Berhad (Malaysia). All rights reserved.
 *
 * This software is proprietary and confidential. Unauthorized copying of this file,
 * via any medium, is strictly prohibited. Do not distribute, copy, modify, or reuse
 * any part of this code without explicit written permission from AirAsia Move.
 *
 * For internal use only.
 */

'use client';

import { useEffect } from 'react';
import { Platform } from 'react-native';
import { useAppConfig } from '@airasia-rn/ui';
import { getSafeLocalStorageItem } from '../utils/safeLocalStorage';

export const getAuthWidgetUrl = (env: string) => {
  /* uncoment this for local testing, you need to
   *  yarn build:auth-widget
   *  yarn start:auth-widget
   */
  // if (['localhost', '127.0.0.1'].includes(window.location.hostname)) {
  //   return 'http://127.0.0.1:8080/dist/main.bundle.js';
  // }

  //todo change this logic when finalized on deployment
  const host =
    env === 'prd'
      ? 'https://airasia.com/v2/account'
      : 'https://account.stgairasia.com';

  return `${host}/auth-widget/main.bundle.js?t=${Date.now()}`;
};

export const useAuthWidget = () => {
  const { config } = useAppConfig();
  const env = config.env as string;

  useEffect(() => {
    if (Platform.OS !== 'web') return;
    if (typeof window === 'undefined' || typeof document === 'undefined')
      return;
    if (!getSafeLocalStorageItem('showV6Auth')) return;

    const existingScript = document.getElementById('login-widget');
    if (existingScript) return;

    const s = document.createElement('script');
    s.src = getAuthWidgetUrl(env);
    s.async = true;
    s.id = 'login-widget';
    s.onload = () => {
      window.authwidget?.init?.({
        recaptchaSiteKey: process.env.EXPO_PUBLIC_RECAPTCHA_SITE_KEY,
        gaCookieName: process.env.EXPO_PUBLIC_GA_COOKIE_NAME,
      });
    };
    document.head.appendChild(s);
  }, [env]);
};
